import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom"; // near the top
function LogOut() {
	const navigate = useNavigate();
	function handleLogOut() {
		localStorage.removeItem("email");
		localStorage.removeItem("token");
		localStorage.removeItem("mealPlans");
		navigate("/"); // redirect to your auth page
	}
	return (
		<div style={{ position: "relative", zIndex: 10 }}>
			<Box
				sx={{
					position: "absolute",
					top: 16, // spacing from top
					right: 16, // spacing from right
					zIndex: 2000,
				}}
			>
				<Button onClick={handleLogOut}>Log Out</Button>
			</Box>
		</div>
	);
}

export default LogOut;
